export default "__VITE_PUBLIC_ASSET__7b49f372__"